module.exports = __webpack_public_path__ + "static/media/polojenie.079a3ebf.pdf";